import { useCallback } from 'react'

interface ShareData {
  title: string
  text: string
  url: string
}

export function useShare() {
  const share = useCallback(async (data: ShareData) => {
    // Use Web Share API if available (Mac, Mobile)
    if (navigator.share) {
      try {
        await navigator.share({
          title: data.title,
          text: data.text,
          url: data.url,
        })
      } catch (error) {
        // User cancelled - expected behavior
        if ((error as Error).name !== 'AbortError') {
          console.error('Share failed:', error)
        }
      }
    } else {
      // Fallback: Copy to clipboard silently
      try {
        await navigator.clipboard.writeText(data.url)
      } catch {
        console.error('Clipboard write failed')
      }
    }
  }, [])

  return { share }
}
